import React from 'react';
import { Row, Col, Button } from 'antd';
import './assets/css/package.css';
import dummyImage from './assets/Rectangle 187.png';
import calendarIcon from './assets/calendar 1.png';
import { useHistory, useParams } from 'react-router';
import { useGetPackagesDetailsByIdQuery } from './packageSlice';

function PackageDetails() {
  const fisheryId = useParams()['fishery_id'];
  const packageId = useParams()['package_id'];
  const history = useHistory();
  const { data: packages } = useGetPackagesDetailsByIdQuery(
    { fishery_id: fisheryId, package_id: packageId },
    {
      skip: !fisheryId && !packageId,
    }
  );
  let Package = packages?.[0];
  return (
    <div className='booking-container'>
      <div
        className='package-details-container details'
        style={{ marginTop: 140 }}
      >
        <Row gutter={[40, 20]} className='package-row '>
          <Col
            xs={{ order: 2, span: 24 }}
            md={{ span: 14, order: 1 }}
            className='package-content'
          >
            <h3 className='package-title'>{Package?.name}</h3>
            <p className='package-description'>{Package?.description}</p>

            {/* Features */}
            <Row gutter={[10, 10]} className='details-package-features'>
              <Col xs={12} sm={8}>
                <span className='feature-item'>
                  <img
                    src={calendarIcon}
                    width={14}
                    height={14}
                    alt='benefit'
                    className='mg-right-5'
                  />{' '}
                  Resort With High-Speed WiFi
                </span>
              </Col>
              <Col xs={12} sm={8}>
                <span className='feature-item'>✅ Breakfast Included</span>
              </Col>
              <Col xs={12} sm={8}>
                <span className='feature-item'>✅ Transfer Included</span>
              </Col>
              <Col xs={12} sm={8}>
                <span className='feature-item'>✅ Boat Included</span>
              </Col>
              <Col xs={12} sm={8}>
                <span className='feature-item'>
                  ✅ Use of Rods and Reels (1x Per Angler)
                </span>
              </Col>
              <Col xs={12} sm={8}>
                <span className='feature-item'>
                  ✅ Use of Check-Out Included
                </span>
              </Col>
            </Row>

            {/* Pricing */}
            <div className='package-pricing'>
              <div className='package-details-price-container mg-bottom-10  row-center justify-between'>
                <span className='package-price-label   font-montserrat sb-blue-700'>
                  PACKAGE PRICE
                </span>
                <div className='package-price  sb-blue-bg-100 font-montserrat sb-blue-700'>
                  £{Package?.final_price_in_pence.toFixed(2)}
                </div>
              </div>
              <div className='package-details-price-container  row-center justify-between'>
                <span className='package-price-label   font-montserrat sb-blue-700'>
                  PAY TODAY
                </span>
                <div className='package-price  sb-blue-bg-100 font-montserrat sb-blue-700'>
                  £{(Package?.final_price_in_pence / 3).toFixed(2)}
                </div>
              </div>
            </div>

            {/* Booking Button */}
            <Button
              className='details-book-button'
              onClick={() => {
                history.push(
                  `/booking/package/reservation/${fisheryId}/${Package?.id}`
                );
              }}
            >
              CHECK AVAILABILITY & BOOK NOW
            </Button>
          </Col>
          <Col
            xs={{ order: 1, span: 24 }}
            md={{ span: 10, order: 2 }}
            className='package-image-container'
          >
            <div className='package-image-wrapper'>
              <img
                src={Package?.package_image}
                alt='Fishing Package'
                className='package-details-image'
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default PackageDetails;
